export const serviceFamilies = [
    { name: "Digital and litho", tags: ["Digital Print", "Offset Print", "Short Run", "Variable Data"] },
    { name: "Wide format", tags: ["Large Format", "Banners", "Pull-ups", "Corflute", "Vinyl & Stickers", "Eco-Solvent Ink"] },
    { name: "Garment", tags: ["T-Shirt Printing", "Screen Printing", "DTF Transfer", "Embroidery", "Heat Press"] },
    { name: "Finishing", tags: ["Lamination", "Foiling", "Die Cutting", "Binding", "Saddle Stitch", "Perfect Bound"] },
    { name: "Labels and packaging", tags: ["Roll Labels", "Die-Cut Stickers", "Packaging Materials"] },
    { name: "Signage", tags: ["Perspex", "ACM", "Lightbox", "Window Vinyl", "Vehicle Wrap"] },
    { name: "Paper and board", tags: ["Paper & Cardstock", "FSC Stock", "Recycled Paper"] },
    { name: "Ink and consumables", tags: ["Toner & Ink", "Litho Inks", "Laminating Film", "Pre-Press Chemicals", "Screen Printing Supplies"] },
    { name: "Equipment", tags: ["Guillotines", "Heat Presses", "Laminators", "Printers & Plotters", "Servicing"] },
];

const displayType = (type) => {
    if (type === "printShop" || type === "ondemand") return "ondemand";
    return type;
};

const formatHours = (hours = {}) => {
    const openDays = Object.entries(hours).filter(([, value]) => value?.open);
    if (!openDays.length) return "Hours not listed";
    return openDays.map(([day, value]) => {
        const label = day.charAt(0).toUpperCase() + day.slice(1, 3);
        return `${label} ${value.openTime || ""}${value.closeTime ? `–${value.closeTime}` : ""}`.trim();
    }).join(" · ");
};

export function normalizePublicStore(uid, store = {}) {
    const address = store.address || {};
    const services = [
        ...(Array.isArray(store.selectedSupplies) ? store.selectedSupplies : []),
        ...(Array.isArray(store.customSupplies) ? store.customSupplies : []),
        ...(Array.isArray(store.inkTypes) ? store.inkTypes : []),
    ].filter((item, index, all) => typeof item === "string" && all.indexOf(item) === index);
    const specials = Array.isArray(store.specials)
        ? store.specials.filter((item) => typeof item === "string" && item.trim())
        : typeof store.special === "string" && store.special.trim()
            ? [store.special.trim()]
            : [];

    return {
        ...store,
        uid: uid || store.uid,
        name: store.shopName || "Print business",
        type: displayType(store.type),
        area: address.suburb || address.city || address.province || "South Africa",
        city: address.city || "",
        province: address.province || "",
        addressText: [address.street, address.suburb, address.city, address.province, address.postalCode].filter(Boolean).join(", "),
        description: store.description || "",
        image: store.shopPhoto || "",
        tags: services,
        specials,
        special: specials[0] || "",
        hoursText: formatHours(store.workingHours),
        coordinates: store.coordinates || address.coordinates || (Number.isFinite(store.lat) && Number.isFinite(store.lng) ? { lat: store.lat, lng: store.lng } : null),
    };
}

const distanceKm = (from, to) => {
    if (!from || !to) return Infinity;
    const radians = (degrees) => (degrees * Math.PI) / 180;
    const dLat = radians(to.lat - from.lat);
    const dLng = radians(to.lng - from.lng);
    const value = Math.sin(dLat / 2) ** 2
        + Math.cos(radians(from.lat)) * Math.cos(radians(to.lat)) * Math.sin(dLng / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(value), Math.sqrt(1 - value));
};

export function isPublicStoreAvailable(store, now = Date.now()) {
    if (store?.serviceAvailableUntilAt == null) return true; // Existing projections are replaced during rollout.
    const deadline = Number(store.serviceAvailableUntilAt);
    return Number.isFinite(deadline) && deadline > now;
}

export function filterPublicStores(stores, filters = {}) {
    const search = (filters.query || "").trim().toLowerCase();
    const area = (filters.area || "").trim().toLowerCase();
    const rows = (stores || []).filter((store) => {
        const searchText = [store.name, store.addressText, store.type, store.description, ...store.tags].join(" ").toLowerCase();
        const areaText = [store.area, store.city, store.province, store.addressText].join(" ").toLowerCase();
        return isPublicStoreAvailable(store, filters.now ?? Date.now())
            && (!search || searchText.includes(search))
            && (!area || areaText.includes(area))
            && (!filters.types?.length || filters.types.includes(store.type))
            && (!filters.services?.length || filters.services.some((tag) => store.tags.includes(tag)))
            && (!filters.special || store.specials.length > 0);
    });

    if (filters.sort === "name") return rows.sort((a, b) => a.name.localeCompare(b.name));
    if (filters.sort === "nearest" && filters.coordinates) {
        return rows.sort((a, b) => distanceKm(filters.coordinates, a.coordinates) - distanceKm(filters.coordinates, b.coordinates));
    }
    return rows.sort((a, b) => Number(b.createdAt || 0) - Number(a.createdAt || 0));
}
